import update from 'immutability-helper'
import { useCallback, useState, useEffect } from 'react'
import { Card } from './CardNivel2.js'
const style = {
  width: '100%',
}
const Container = ({modulos, onAcordionContenido, onShowModal, onEliminar}) => {
    
  
    const [cards, setCards] = useState(modulos);
    
    
    useEffect(() => {
        //Runs on every render
        if(modulos.contenidoUpdate!=cards.contenidoUpdate){
            setCards(modulos);
        }
    });
      
    const moveCard = useCallback((dragIndex, hoverIndex) => {
      setCards((prevCards) =>
        update(prevCards, {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, prevCards[dragIndex]],
          ],
        }),
      )
    }, [])
    const renderCard = useCallback((card, index, onAcordionContenido, onShowModal) => {
         card.index=index;
      return (
        <Card
          key={card.id}
          description={card.agrupador}
          contenido={card.contenido}
          index={index}
          id={card.id}
          text={card.text}
          titulo={card.fecha}
          moveCard={moveCard}
          activo={card.activo}
          contenidoView={card.contenidoUI}
          onAcordionContenido={onAcordionContenido}
          onShowModal={onShowModal}
          onEliminar={onEliminar}
          card={card}
        />
      )
    }, [])
    return (
            
      <>
        <div style={style}>{cards.map((card, i) => renderCard(card, i, onAcordionContenido, onShowModal))}</div>
      </>
    )
  
}

export default Container;